import api from '@/api/apiErp/apiUser';

export default {
  async getCurrent({ commit, dispatch }) {
    try {
      let user;
      const userResponse = await api.getCurrent();
      if (userResponse.status === 200) {
        user = userResponse.data;
      }
      if (user) {
        commit('setCurrent', user);
      }
      const { hash } = window.location;
      const params = hash.substr(hash.indexOf('?') + 1).split('&').reduce((result, item) => {
        const parts = item.split('=');
        result[parts[0]] = parts[1];
        return result;
      }, {});
      if (params.siteKey && user.company_id === 1) {
        commit('setOverrideAccount', params.siteKey);
      }
    } catch (e) {
      throw e;
      // dispatch('errorHandler/throwDefaultError', e, { root: true });
    }
  },
};
